module.exports = __webpack_public_path__ + "static/media/closeMenu.671f5a8b.mp3";